import * as Yup from "yup";

import {
  OfficeButton,
  PDFRenderer,
  RegularInsurerPicker,
  RegularSelectInput,
} from "components";
import { useEffect, useState } from "react";

import _ from "lodash";
import config from "config";
import moment from "moment";
import { useFormik } from "formik";
import { useStatementPaidCheques } from "hooks/data/use-statement-paid-cheques";
import { wrapClick } from "utils";

type Props = {};

const startYear = 2019;
const currentYear = moment().year();
const yearList = Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
  const year = startYear + i;
  return {
    label: year.toString(),
    value: year.toString(),
  };
});

const treatyURl = {
  Proportional: `treaty_proportional_production_report`,
  NonProportional: `treaty_xl_production_report`
}

const ReportingTab = () => {
  const form = useFormik<any>({
    initialValues: {
      year: "",
      based_on: "",
      insurer: "",
      treaty_type: "",
    },
    onSubmit: () => {
      form.setFormikState((state) => ({ ...state, status: "SUBMIITED" }));
      form.setSubmitting(false);
      generateReport(form.values);
      return;
    },
    validationSchema: Yup.object().shape({
      treaty_type: Yup.string().required("Treaty Type is required"),
      based_on: Yup.string().required("Based on is required"),
      insurer: Yup.string().notRequired(),
      year: Yup.string().required("Year is required"),

    }),
    initialStatus: "NOT_SUBMIITED",
  });
  const { loadingCheques, cheques } = useStatementPaidCheques();
  const [url, setUrl] = useState("");


  useEffect(() => {
    form.setFormikState((state) => ({ ...state, status: "NOT_SUBMIITED" }));
    form.setSubmitting(false);
  }, [form.values.currency, form.values.date, form.values.cheque]);

  const generateReport = (data: any) => {
    const { treaty_type, year, insurer, based_on } = data;
    const url = `${config.asset.uri}${_.get(treatyURl, treaty_type, 'treaty_proportional_production_report')}/${btoa(JSON.stringify({ treaty_type, year, insurer, based_on }))}`;
    setUrl(url);
  }

  return (
    <div className="w-full">
      <div className="py-3 flex justify-between">
        <h1 className="font-bold text-primary text-lg">Build Treaty Report</h1>
        <div>
          <OfficeButton
            disabled={form.isSubmitting}
            onClick={wrapClick(form.handleSubmit)}
          >
            {form.isSubmitting ? "Generating ..." : "Generate Report"}
          </OfficeButton>
          {/* {form.status === "SUBMIITED" && form.isValid && (
            <a href="https://manage.visalreinsurance.com/generate_brokerage_statement_excel">
              <OfficeButton variant="success" onClick={undefined}>Download Excel</OfficeButton>
            </a>
          )} */}
        </div>
      </div>
      <form className="bg-white py-6 px-6 h-auto">
        <div className="grid gap-3  grid-cols-2 shadow-sm">
          <div>
            <RegularSelectInput
              id="treaty_type"
              label="Treaty Type"
              options={[
                { label: "Proportional", value: "Proportional" },
                { label: "Non-Proportional", value: "NonProportional" },
              ]}
              placeholder="Treaty Type"
              required={true}
              {...form}
            />
          </div>
          <div>
            <RegularSelectInput
              id="year"
              label="Year"
              options={yearList}
              placeholder="Year"
              required={true}
              {...form}
            />
          </div>
          <div className="">
            <RegularInsurerPicker
              optionsLoading={loadingCheques}
              required={false}
              rawId
              id={"insurer"}
              description="Don't select insurer if you want to generate report for all insurers"
              label={"Insurer"}
              placeholder="select Insurer"
              {...form}
            />
          </div>
          <div>
            <RegularSelectInput
              id="based_on"
              label="Based On"
              options={[
                { label: "Brokerage", value: "Brokerage" },
                { label: "Commission", value: "Commission" },
                { label: "Premium", value: "Premium" },
              ]}
              placeholder="Based On"
              required={true}
              {...form}
            />
          </div>
        </div>
      </form>
      <div className="pt-11">
        {form.status === "SUBMIITED" && form.isValid && (
          <PDFRenderer
            url={url}
          />
        )}
      </div>
    </div>
  );
};

export default ReportingTab;
